import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-bold font-size-18 mb-1" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "font-size-14 mb-4" }
const _hoisted_5 = { class: "font-bold font-bold mb-1" }
const _hoisted_6 = { class: "flex justify-end" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.t('applicableDate')), 1),
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('selectTheStartDateToApplyTheConfigurationChange')), 1),
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.t('applicableDate')), 1),
      _createVNode(_component_DatePicker, {
        width: "100",
        type: "month",
        format: _ctx.MONTH_FORMAT,
        validated: _ctx.validated,
        required: "",
        errors: _ctx.errorData['apply_start_date'],
        "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorData['apply_start_date'] = $event)),
        modelValue: _ctx.apiPostParams.apply_start_date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apiPostParams.apply_start_date = $event)),
        "error-server": _ctx.errorServer.apply_start_date
      }, null, 8, ["format", "validated", "errors", "modelValue", "error-server"])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        variant: "outline-primary",
        class: "w-38 mr-4",
        onClick: _ctx.onClosePopup
      }, {
        default: _withCtx(() => [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.t('cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        onClick: _ctx.onSubmit,
        disabled: _ctx.isDisableSubmit,
        class: "w-38"
      }, {
        default: _withCtx(() => [
          _hoisted_8,
          _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ]))
}